import Seo from "@/components/Seo";
import { HomeExperience } from "@/components/acquisition/Home";

const Index = () => {
  return (
    <><Seo title="TeleAds | Paid Acquisition for Telehealth Brands" description="Paid media, creative and custom-scoped patient acquisition systems for telehealth brands. Improve the path from first click to patient conversion." path="/" /><HomeExperience /></>
  );
};

export default Index;
